import catalog from '../../../desktop/proxy/src/browser-check/catalog.json';
import { venueCanon } from './venues';

export type SelectionSource = 'filters' | 'studio';
export interface VenueFilter { venues: string[]; mainVenues: string[]; venueMode: 'only' | 'except' }
const codes = (values: string[]) => new Set(values.map(venueCanon));
/** Translate account aliases to diagnostic IDs; never copy an exclusion list as inclusion. */
export function diagnosticSelection(filter: VenueFilter, books: Record<string, boolean>, source: SelectionSource): string[] {
  const studio = Object.keys(books).filter(id => books[id]);
  const mains = codes(filter.mainVenues), chosen = codes(filter.venues);
  let wanted: Set<string>;
  if (source === 'studio') wanted = codes(studio);
  else if (filter.venueMode === 'only') wanted = codes([...filter.venues, ...filter.mainVenues]);
  else if (chosen.size) wanted = codes(catalog.venues.map(v => v.id));
  else wanted = codes(filter.mainVenues.length ? filter.mainVenues : studio);
  if (filter.venueMode === 'except') for (const id of chosen) if (!mains.has(id)) wanted.delete(id);
  return catalog.venues.filter(v => wanted.has(venueCanon(v.id))).map(v => v.id);
}
